import type { PageLoad } from './$types';
import { error } from '@sveltejs/kit';
import { loadPublishedMeetingMinutes } from '$lib/utils/meetingLoader';
import { MeetingPathSchema } from '$lib/types/meeting';

export const load: PageLoad = async ({ params }) => {
	const year = params.year;

	// Validate year parameter using Zod schema
	const yearValidation = MeetingPathSchema.shape.year.safeParse(year);
	if (!yearValidation.success) {
		throw error(404, 'Invalid year format');
	}

	// Load published meetings for the specified year using Zod-validated loader
	const meetings = await loadPublishedMeetingMinutes(year);

	return {
		year,
		meetings
	};
};
